import { Link } from "react-router-dom";
import { PageHeader, Reveal } from "@/components/site/Reveal";
import { IMG } from "@/lib/images";

const STEPS = ["Første samtale og ønsker", "Skisse, stoffvalg og mål", "Prøvinger underveis", "Ferdig kjole – helt din"];

export default function Bridal() {
  return (
    <div data-testid="bridal-page">
      <PageHeader eyebrow="Brudekjoler og festantrekk" title="Unike kjoler. Unike historier." intro="Begge veier gir deg en helt personlig og unik brudekjole – enten du vil sy den selv med veiledning, eller få den skreddersydd av Liisa." testid="bridal-header" />
      <section className="px-6 md:px-16 lg:px-24 grid lg:grid-cols-2 gap-10">
        {[
          ["Sy din egen brudekjole", "Skap kjolen etter eget design, lær å sy under veiledning og følg hele prosessen i ditt eget tempo. Hver time avtales individuelt.", IMG.machine, "kurs"],
          ["Få kjolen skreddersydd", "Utvikle designet sammen med Liisa og få en unik brudekjole som ingen andre har maken til.", IMG.heroBridal, "brudekjole"],
        ].map(([t, d, img, type], i) => (
          <Reveal key={t} delay={i * 0.15} className="border border-[#E5E0D8] bg-[#FDFBF7]">
            <img src={img} alt={t} className="w-full h-80 object-cover" />
            <div className="p-10">
              <p className="eyebrow">Vei {i + 1}</p>
              <h2 className="text-4xl font-medium mt-3">{t}</h2>
              <p className="mt-4 text-[#5C5A56] leading-relaxed">{d}</p>
              <Link to={`/bestill?type=${type}#forespørsel`} className="inline-block mt-8 px-7 py-3.5 bg-[#1A1A1A] text-[#FDFBF7] text-sm hover:bg-[#8C6E48] transition-colors" data-testid={`bridal-path-${i}-btn`}>Ta kontakt</Link>
            </div>
          </Reveal>
        ))}
      </section>
      <section className="px-6 md:px-16 lg:px-24 py-24 grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-5">
          <p className="eyebrow mb-4">Slik foregår det</p>
          <h2 className="text-4xl font-medium tracking-tight">Fra drøm til ferdig kjole</h2>
          <ol className="mt-10 space-y-6">
            {STEPS.map((s, i) => <li key={s} className="flex gap-6 items-baseline border-b border-[#E5E0D8] pb-5"><span className="font-serif-display text-3xl text-[#C4A47C]">0{i + 1}</span><span className="text-lg">{s}</span></li>)}
          </ol>
          <p className="mt-8 text-sm text-[#5C5A56]">Pris avtales individuelt etter konsultasjon. Vi anbefaler å ta kontakt i god tid før bryllupet.</p>
        </Reveal>
        <Reveal className="lg:col-span-6 lg:col-start-7" delay={0.1}>
          <img src={IMG.festwear} alt="Festantrekk – dress og rød kjole" className="w-full h-[560px] object-cover" />
        </Reveal>
      </section>
    </div>
  );
}
